
export class ClientUtilities {
    public static getRootWindowInSameDomain(win) {
        var top = window;
        var win = win || window;
        
        while (win.parent != win) {
          try {
            // when the parent window is from a different domain accessing any property from window will throw cross origin access exception
            if(win.parent.document) {
                top = win.parent;
            }
          } catch (e) {}
            win = win.parent;
        }
        return top;
    }

    public static runningInPluginUI(): boolean {
        // WEB_PLATFORM is the VMware Web Client platform reference.
        // When the Flex client is running it is defined as the Flash container.

        if(localStorage.getItem('hcx-remote-plugin-context')){
            console.debug('Running in remote plugin UI');
            return true;
        }

        const WEB_PLATFORM = self.top.document.getElementById('container_app');

        if (!WEB_PLATFORM) {
            // no FLEX client
            let htmlClientSdk = (window as any).htmlClientSdk || (window.frameElement && (window.frameElement as any).htmlClientSdk);
            if (!htmlClientSdk) {
                // no HTML5 client - lets try again
                const topFrame = ClientUtilities.getRootWindowInSameDomain(window);
                htmlClientSdk = (topFrame as any).vSphereClientSDK && (topFrame as any).vSphereClientSDK.getWebPlatformApi &&
                    (topFrame as any).vSphereClientSDK.getWebPlatformApi(window);
                if (!htmlClientSdk) {
                    // still no HTML5 client
                    const vsphereFlexClientPath = (window.location.pathname.match(/(.*)(\/vsphere-client\/hcx)(\/.*|$)/) || [])[0];
                    if (!!vsphereFlexClientPath) {
                        return true;
                    }
                    const vsphereHtml5ClientPath = (window.location.pathname.match(/(.*)(\/ui\/hcx)(\/.*|$)/) || [])[0];
                    if (!!vsphereHtml5ClientPath) {
                        return true;
                    }
                    return false;
                }
            }
            return true;
        } else {
            return true;
        }
    }
}



// WEBPACK FOOTER //
// ./src/alerts/src/alerts-ui/utils/client-utils.ts